import { render, staticRenderFns } from "./courseB.vue?vue&type=template&id=18c1d797&scoped=true&"
import script from "./courseB.vue?vue&type=script&lang=js&"
export * from "./courseB.vue?vue&type=script&lang=js&"
import style0 from "./courseB.vue?vue&type=style&index=0&id=18c1d797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1d797",
  null
  
)

export default component.exports